module.exports = __webpack_public_path__ + "static/img/banner_AI审核.82924f06.png";